// import React, { useContext, useEffect, useState } from "react";
// import SideMenu from "./SideMenu";
// import { HiOutlineMenu, HiOutlineX } from "react-icons/hi";
// import { UserContext } from "../../context/UserContext";
// import { io } from 'socket.io-client';
// import { API_PATHS, BASE_URL } from "../../utils/apiPaths";
// import toast from "react-hot-toast";

// const socket = io(BASE_URL); 
// const Navbar = ({ activeMenu }) => {
//   const [openSideMenu, setOpenSideMenu] = useState(false);
//   const [notifications, setNotifications] = useState([]);
//   const [showPopup, setShowPopup] = useState(false);
//   const { user} = useContext(UserContext);
//   const userId = user?._id;
  
//   useEffect(() => {
//     socket.emit('join', userId);

//     socket.on('new_notification', (notification) => {
//       // Ajouter à la liste
//       setNotifications(prev => [notification, ...prev]);

//       // Afficher toast
//       toast.info(notification.message, {
//         position: "top-right",
//         autoClose: 5000, // se ferme après 5 secondes
//         hideProgressBar: false,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: true,
//         progress: undefined,
//       });
//     })
//         // Charger notifications existantes
//     fetch(API_PATHS.NOTIFY.GET_NOTIFICATIONS(userId))
//       .then(res => res.json())
//       .then(data => setNotifications(data));

//     return () => socket.off('new_notification');
//   }, []);

//     const unreadCount = notifications.filter(n => !n.read).length;

//      const markAsRead = async (id) => {
//     await fetch(API_PATHS.NOTIFY.MARK_AS_READ, { method: 'PUT' });
//     setNotifications(prev => prev.map(n => n._id === id ? { ...n, read: true } : n));
//   };

//   return (
//     <div className="flex bg-white border border-b border-gray-200/50 backdrop-blur-[2px] py-4 px-7 sticky top-0 w-full items-center justify-between">
//       {/* Bouton menu mobile */}
//       <button
//         className="block lg:hidden text-black"
//         onClick={() => setOpenSideMenu(!openSideMenu)}
//       >
//         {openSideMenu ? (
//           <HiOutlineX className="text-2xl" />
//         ) : (
//           <HiOutlineMenu className="text-2xl" />
//         )}
//       </button>

//       {/* Logo / Titre */}
//       <h2 className="text-lg font-bold text-blue-600">Convivium</h2>
//       {/* Section notifications */}
//         <div className="p-6 font-sans min-h-screen bg-gray-50">
//   <h1 className="text-2xl font-semibold mb-6 text-gray-800">
//     Notifications Temps Réel
//   </h1>

//   {/* Badge + popup */}
//   <div className="relative inline-block">
//     <button
//       onClick={() => setShowPopup(!showPopup)}
//       className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg shadow hover:bg-blue-700 transition"
//     >
//       Notifications
//       {unreadCount > 0 && (
//         <span className="bg-red-500 text-white text-xs font-bold rounded-full px-2 py-0.5">
//           {unreadCount}
//         </span>
//       )}
//     </button>

//     {showPopup && (
//       <div className="absolute top-12 right-0 w-80 max-h-96 overflow-y-auto bg-white border border-gray-200 shadow-lg rounded-xl z-50 p-3">
//         {notifications.length === 0 && (
//           <p className="text-gray-500 text-sm text-center py-4">
//             Aucune notification
//           </p>
//         )}

//         {notifications.map((n) => (
//           <div
//             key={n._id}
//             onClick={() => markAsRead(n._id)}
//             className={`mb-2 p-3 rounded-lg cursor-pointer transition ${
//               n.read
//                 ? "bg-gray-100 hover:bg-gray-200"
//                 : "bg-blue-50 hover:bg-blue-100"
//             }`}
//           >
//             <p className="font-medium text-gray-800">{n.message}</p>
//             <small className="text-gray-500 text-xs">
//               {new Date(n.createdAt).toLocaleString()}
//             </small>
//           </div>
//         ))}
//       </div>
//     )}
//   </div>
// </div>

//         {/* fin sectionnotification */}
//       {/* Menu latéral */}
//       {openSideMenu && (
//         <div className="fixed top-[59px] left-0 w-3/4 h-full bg-white  z-80">
//           <SideMenu activeMenu={activeMenu} />
//         </div>
//       )}
//     </div>
//   );
// };

// export default Navbar;

import React, { useContext, useEffect, useState } from "react";
import SideMenu from "./SideMenu";
import { HiOutlineMenu, HiOutlineX } from "react-icons/hi";
import { Bell } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { UserContext } from "../../context/UserContext";
import { io } from "socket.io-client";
import { API_PATHS, BASE_URL } from "../../utils/apiPaths";
import toast from "react-hot-toast";

const socket = io(BASE_URL);

const Navbar = ({ activeMenu }) => {
  const [openSideMenu, setOpenSideMenu] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const { user } = useContext(UserContext);
  const userId = user?._id;

  // useEffect(() => {
  //   if (!userId) return;

  //   socket.emit("join", userId);

  //   socket.on("new_notification", (notification) => {
  //     setNotifications((prev) => [notification, ...prev]);
  //     toast(notification.message, { icon: "🔔" });
  //   });

  //   fetch(API_PATHS.NOTIFY.GET_NOTIFICATIONS(userId))
  //     .then((res) => res.json())
  //     .then((data) => setNotifications(data));

  //   return () => socket.off("new_notification");
  // }, [userId]);

  // Dans Navbar.js
useEffect(() => {
  if (!userId) {
    console.log("UserId manquant");
    return;
  }

  console.log("Connexion Socket.IO avec userId:", userId);
  socket.emit("join", userId);

  socket.on("connect", () => {
    console.log("Connecté à Socket.IO");
  });

  socket.on("new_notification", (notification) => {
    console.log("Nouvelle notification reçue:", notification);
    setNotifications((prev) => [notification, ...prev]);
    toast(notification.message, { icon: "🔔" });
  });

  // Testez l'API
  fetch(API_PATHS.NOTIFY.GET_NOTIFICATIONS(userId))
    .then((res) => {
      console.log("Statut réponse notifications:", res.status);
      return res.json();
    })
    .then((data) => {
      console.log("Notifications chargées:", data);
      setNotifications(data);
    })
    .catch(err => console.error("Erreur chargement notifications:", err));

  return () => socket.off("new_notification");
}, [userId]);
  const unreadCount = notifications.filter((n) => !n.read).length;

  const markAsRead = async (id) => {
    await fetch(API_PATHS.NOTIFY.MARK_AS_READ(id), { method: "PUT" });
    setNotifications((prev) =>
      prev.map((n) => (n._id === id ? { ...n, read: true } : n))
    );
  };

  return (
    <>
      {/* ===== NAVBAR ===== */}
      <nav className="flex items-center justify-between bg-white border-b border-gray-200/50 backdrop-blur-sm py-3 px-6 sticky top-0 w-full z-50 shadow-sm">
        {/* --- Bouton menu mobile --- */}
        <button
          className="block lg:hidden text-gray-700"
          onClick={() => setOpenSideMenu(!openSideMenu)}
        >
          {openSideMenu ? (
            <HiOutlineX className="text-2xl" />
          ) : (
            <HiOutlineMenu className="text-2xl" />
          )}
        </button>

        {/* --- Logo / Titre --- */}
        <h2 className="text-lg font-bold text-blue-600 tracking-wide">
          Convivium
        </h2>

        {/* --- Icône notifications --- */}
        <div className="relative">
          <button
            onClick={() => setShowPopup(!showPopup)}
            className="relative flex items-center justify-center w-10 h-10 rounded-full hover:bg-gray-100 transition"
          >
            <Bell className="w-6 h-6 text-gray-700" />
            {unreadCount > 0 && (
              <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full px-1.5 py-0.5">
                {unreadCount}
              </span>
            )}
          </button>

          {/* --- Popup Notifications --- */}
          <AnimatePresence>
            {showPopup && (
              <motion.div
                initial={{ opacity: 0, y: -8 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -8 }}
                transition={{ duration: 0.2 }}
                className="absolute right-0 mt-3 w-80 max-h-96 overflow-y-auto bg-white border border-gray-200 shadow-xl rounded-xl z-50 p-3"
              >
                {notifications.length === 0 && (
                  <p className="text-gray-500 text-sm text-center py-4">
                    Aucune notification
                  </p>
                )}
                {notifications.map((n) => (
                  <div
                    key={n._id}
                    onClick={() => markAsRead(n._id)}
                    className={`mb-2 p-3 rounded-lg cursor-pointer transition ${
                      n.read
                        ? "bg-gray-100 hover:bg-gray-200"
                        : "bg-blue-50 hover:bg-blue-100"
                    }`}
                  >
                    <p className="font-medium text-gray-800">{n.message}</p>
                    <small className="text-gray-500 text-xs">
                      {new Date(n.createdAt).toLocaleString()}
                    </small>
                  </div>
                ))}
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </nav>

      {/* ===== MENU LATÉRAL MOBILE ===== */}
      {openSideMenu && (
        <div className="fixed top-[59px] left-0 w-3/4 h-full bg-white shadow-lg z-40">
          <SideMenu activeMenu={activeMenu} />
        </div>
      )}
    </>
  );
};

export default Navbar;
